import Reveal from "@/components/Reveal";

const STATS = [
  { label: "Founded", value: "2026" },
  { label: "First Simulator Release", value: "October 2026" },
  { label: "Contact", value: "info@qpilabs.ai", mailto: true },
];

export default function WhoWeAre() {
  return (
    <section id="who-we-are" className="relative pb-28 md:pb-40" data-testid="who-we-are-section">
      <div className="container-x">
        <Reveal>
          <p className="eyebrow mb-4 text-laser">— Who We Are</p>
          <h2 className="max-w-3xl text-4xl font-semibold tracking-tighter md:text-5xl">
            We build the tools that let you think in light.
          </h2>
        </Reveal>

        <Reveal delay={0.05}>
          <div className="mt-8 max-w-2xl space-y-5 font-mono text-[13px] leading-relaxed text-zinc-400">
            <p>
              QPI Laboratories was founded in 2026 by Dr. Andreas Falkenberg — serial inventor at
              the intersection of photonics and machine learning. The mission is singular: make
              photonic AI compute explorable before it becomes silicon.
            </p>
            <p>
              We believe the transition from electronic to photonic inference is inevitable. The
              researchers and engineers who lead that transition need simulation infrastructure
              precise enough to inform real hardware decisions — before a single chip is fabbed.
              The QPI Labs simulator is the first step.
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-3">
          {STATS.map((stat, i) => (
            <Reveal key={stat.label} delay={0.05 * i}>
              <div
                className="rounded-lg border border-white/10 bg-panel p-5"
                style={{ boxShadow: "inset 0 0 24px rgba(61,107,255,0.08)" }}
                data-testid={`whoweare-stat-${i}`}
              >
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">{stat.label}</p>
                {stat.mailto ? (
                  <a
                    href={`mailto:${stat.value}`}
                    data-testid="whoweare-contact-link"
                    className="mt-3 inline-block font-mono text-sm font-bold text-beam transition-colors hover:underline"
                  >
                    {stat.value}
                  </a>
                ) : (
                  <p className="mt-3 font-mono text-sm font-bold text-white">{stat.value}</p>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
